import React from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import newsData from "../Components/Shared/NewsData";
import { Box, Typography } from "@mui/material";

const NewsDetails = () => {
  const { slug } = useParams();

  const newsItem = newsData.find(
    (item) => item.slug === slug
  );

  if (!newsItem) {
    return (
      <Container className="py-5">
        <Row>
          <Col>
            <h2>News not found</h2>
            <p>The news article you are looking for does not exist.</p>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <>
      {/* Page Animation Wrapper */}
      <motion.div
        initial={{ y: 60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <section
          className="news-details-section"
          style={{ backgroundColor: "#f8f9ff", padding: "4rem 0" }}
        >
          <Container>
            {/* Video Section */}
            <Row className="mb-4">
              <Col lg={12} className=" m-auto">
                <Box
                  style={{
                    position: "relative",
                    paddingTop: "45%",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <iframe
                    src={newsItem.videoUrl.replace(
                      "youtu.be/",
                      "www.youtube.com/embed/"
                    )}
                    title={newsItem.title}
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                  />
                </Box>
              </Col>
            </Row>

            {/* Title & Meta */}
            <Row className="mb-3">
              <Col lg={12} className="serRight-text">
               <Typography variant="h2" style={{margin:"25px  0 0"}}>
                  {newsItem.title}
                </Typography>
                <Typography variant="body1" style={{padding:'0', color:'#ababab', marginBottom:'20px'}}>
                    {new Date(newsItem.date).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                </Typography>
              </Col>
            </Row>

            {/* Content */}
            <Row>
              <Col lg={12}>
                <p style={{ lineHeight: "1.8", fontSize: "16px" }}>
                  {newsItem.content}
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </motion.div>
    </>
  );
};

export default NewsDetails;
